module.exports = __webpack_public_path__ + "static/verbindingstolken-d54a48f2c92acd1269380406bd08ab87.jpg";